/*
 * controllers/spaController.js
 * Spa Controller
 */

define('app/controllers/spaController',[
    'app/ControllerClass',
    'app/models/spaModel',
    'app/views/spaView',
    'moment'
], function (ControllerClass, SpaModel, SpaView,moment) {
    return window.app.controllers.spaController = $.extend({}, ControllerClass, {
        app:app,
        module:'spa',

        actions:{
            'show':['spaBookingSelected'],
            'location':['spaLocationSelected'],
            'service':['spaServiceSelected'],
            'serviceItem':['spaItemSelected'],
            'serviceStaffList':['spaServiceStaffListRequested'],
            'eventcalendar':['spaEventCalendar'],
            'class':['spaClassSelected'],
            'findclass':['spaClassDateSelected'],
            'confirmClass':['spaClassConfirmation','class'],
            'confirmEvent':['spaClassConfirmation','event'],
            'bookClass':['bookSpaClass'],
            'book':['bookSpaItem'],
            'package': ['spaPackageSelected'],
            'bookPackage':['bookSpaPackage'],
            'WaitList': ['AddWaitList'],
            'partialPayment':['spaPartialPayment']
            

        },
        init:function () {
            console.log('initializing spa controller');
            app.data.messages = app.data.messages || [];

            /*
             // this is trivial method overloading
             // save super
             this._pfa = this.performAction;
             // replace it
             this.performAction = function(action) {
             if(!app.customization.login.atCheckOut && !app.data.userLoggedIn) {
             app.dispatcher.redirect('profile','login',['next','spaBooking', action, [].slice.call(arguments,1)]);
             } else {
             // call saved super
             this._pfa.apply(this, arguments)
             }
             }
             */
            this._init.call(this);
        },

        spaBookingSelected:function () {
            var self = this;
            $.when(
                app.models.spaModel.getData('spaLocations', {}),
                (app.customization.hideOtherPropertyIfItemsInCart && app.models.systemModel.validatePMSBeforeSpa())
            )
                .done(function (r_sl, r_pbs) {

                    if (!!r_sl.SpaLocation && r_sl.SpaLocation.length > 0) {

                        var spaLocations = r_sl.SpaLocation;
                        // Dynamic restriction code for enable Spa Locations
                        if(app.customization.dynamicRestrictions && app.commonViewHelper.activeEffects.enableSpaLocations){
                            var enableSpaLocationsResult = app.commonViewHelper.groupEffects(app.commonViewHelper.activeEffects.enableSpaLocations);
                            if(enableSpaLocationsResult.isActive && enableSpaLocationsResult.value && enableSpaLocationsResult.value.length){
                                if(typeof enableSpaLocationsResult.value == 'object' && enableSpaLocationsResult.value.length && typeof enableSpaLocationsResult.value[0] == 'function'){
                                    _.each(enableSpaLocationsResult.value, function(func){
                                        spaLocations = func(spaLocations);                                    
                                    })
                                } else {
                                    spaLocations = _.filter(spaLocations, function(spaLocation){
                                        return _.contains(enableSpaLocationsResult.value, spaLocation.LocationId);
                                    });
                                }
                            }                        
                        }
                        if (spaLocations.length == 0) {
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                title: app.localization.spaBooking.locationSelection.err.noLocationAccess,
                                message: '' // r_pr.Result ? "(" + r_pr.Result.Text + ")" : ""
                            });
                            app.dispatcher.replace('','',[]);
                            return;
                        }
                        // Dynamic restriction code for enable Spa Locations
                        if (app.customization.hideOtherPropertyIfItemsInCart && (app.data.spaPropertyIdsInCart.length > 0 || app.data.pmsPropertyIdsInCart.length > 0)) {
                            spaLocations = _.filter(spaLocations,function(x){
                                return _.any(app.data.spaPropertyIdsInCart, function(y){ return y==x.PropertyId }) || _.any(app.data.pmsPropertyIdsInCart, function(y){ return y==x.PropertyId })
                            })
                            if (spaLocations.length==0) {
                                app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                    title: app.localization.spaBooking.locationSelection.err.noLocationsAtProperty,
                                    message: '' // r_pr.Result ? "(" + r_pr.Result.Text + ")" : ""
                                });
                                app.dispatcher.redirect('summary','',[]);
                                return;
                            }
                        }

                        if (r_pbs && location.PMSRoomMandatory == "Y") {
                            app.data.messages.push({
                                type:'alert', 'class':'alert-info alert-no-autoclose', actions:[],
                                title:app.localization.spaBooking.pmsbeforespa.notice
                            });
                        }
                        if(app.customization.declareGuestsOn.SPA && (!app.data.store || app.data.store.WebFolioId != app.data.WebFolioId || !app.data.store.groupMembersSelected)) {
                            app.views.spaView.event.fire('requestBookingTypeSelectionAfterSpa',[spaLocations, app.models.spaModel.getSelectedItem('spaLocations', {})]);
                        } else{
                            app.views.spaView.event.fire('requestSpaLocationSelection', [spaLocations, app.models.spaModel.getSelectedItem('spaLocations', {})]);
                        }
                    } else {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                            title:app.localization.spaBooking.locationSelection.err.noLocation/*,
                            message:"(" + r_ss.Result.Text + ")"*/
                        });
                        app.dispatcher.redirect('');
                    }
                })
                .fail(function (r_sl) {
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                        title:app.localization.spaBooking.locationSelection.err.noLocation
                    });
                    app.dispatcher.redirect('');
                });
        },

        spaLocationSelected:function (spaLocationId) {
            app.models.spaModel.setSelected('spaLocations', {}, spaLocationId);
            var self = this,
                location = app.models.spaModel.getSelectedItem('spaLocations', {});
            if (app.customization.spaBooking.allowBookClass) {

                if (location.PMSRoomMandatory == "Y") {
                    app.models.systemModel.validatePMSBeforeSpa(location.LocationName).done(function(r_pbs){
                        if (r_pbs) {
                            app.data.messages.push({ type:'alert', 'class':'alert-info alert-no-autoclose', actions:[],
                                title:app.localization.spaBooking.pmsbeforespa.notice
                            });
                        }
                        app.views.spaView.event.fire('requestSpaServiceTypeSelection', [spaLocationId]);
                    });
                } else {
                    app.views.spaView.event.fire('requestSpaServiceTypeSelection', [spaLocationId]);

                }
            } else {
                self.spaServiceSelected('Location' + spaLocationId);
            }
        },

        spaServiceSelected:function (showitem, date, time, staffGenderOrId, guestName, runQuery) {
            if (showitem && showitem.substr(0, 8) == "Location") {
                var showitemParts = showitem.split('|');
                app.models.spaModel.setSelected('spaLocations', {}, showitemParts[0].substr(8));
                showitem = showitemParts[1];
            }
            var self = this,
                loadProfileData = false,
                location = undefined;
            if (app.data.userLoggedIn) {
                loadProfileData = true;
                params = {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    },
                    dfd = $.Deferred();
                app.models.userModel.getData('fetchGroupMembers', params ).always(function(x){
                    dfd.resolve(x);
                })
                var profileParams = {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    }
            }

            staffGenderOrId && app.datal('staffGenderOrId', staffGenderOrId);
            app.models.spaModel.getData('spaLocations', {}).done(function(r_sl){
                location = app.models.spaModel.getSelectedItem('spaLocations', {});
                if (!location) {
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                        title:app.localization.spaBooking.locationSelection.err.noLocation,
                        message: '' // r_pr.Result ? "(" + r_pr.Result.Text + ")" : ""
                    });
                    app.dispatcher.redirect('summary','',[]);
                    return;
                }
                $.when(
                    app.models.spaModel.getData('spaServicesByCategory', {}),
                    ((location.PMSRoomMandatory == "Y"||app.customization.hideOtherPropertyIfItemsInCart) && app.models.systemModel.validatePMSBeforeSpa(location.LocationName)),
                    (loadProfileData && app.models.userModel.getData('fetchCustomerProfile', profileParams )),
                    (loadProfileData && dfd.promise())

                )
                    .done(function (r_sc, r_pbs, r_fcp, r_fgm) {
                        r_sc = r_sc.filter(function(item){ return item.name != "Spa Package" }); //to remove package items as this ui does not handle it
                        var spaLocations = r_sl.SpaLocation;
                        if (app.customization.hideOtherPropertyIfItemsInCart && (app.data.spaPropertyIdsInCart.length > 0 || app.data.pmsPropertyIdsInCart.length > 0)) {
                            spaLocations = _.filter(spaLocations,function(x){
                                return _.any(app.data.spaPropertyIdsInCart, function(y){ return y==x.PropertyId }) || _.any(app.data.pmsPropertyIdsInCart, function(y){ return y==x.PropertyId })
                            })
                            if (spaLocations.length==0) {
                                app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                    title:app.localization.spaBooking.locationSelection.err.noLocationsAtProperty,
                                    message: '' // r_pr.Result ? "(" + r_pr.Result.Text + ")" : ""
                                });
                                app.dispatcher.redirect('summary','',[]);
                                return;
                            } else if (!_.any(spaLocations,function(x){return x.LocationId == location.LocationId})) {
                                app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                    title:app.localization.spaBooking.locationSelection.err.mismatchedProperty,
                                    message: '' // r_pr.Result ? "(" + r_pr.Result.Text + ")" : ""
                                });
                                app.dispatcher.redirect('summary','',[]);
                                return;
                            }
                        }
                        showitem = showitem || // $.firstOrOnly($.first(r_sc).value.value).SpaItemId;
                                   ( $.isArray(r_sc) && $.isArray($.first(r_sc).value) &&
                                        r_sc.length==1 && $.first(r_sc).value.length==1
                                        ? $.firstOrOnly($.first(r_sc).value.value).SpaItemId : "" );
                        if (location.PMSRoomMandatory == "Y") {
                            if (r_pbs) {
                                app.data.messages.push({ type:'alert', 'class':'alert-info alert-no-autoclose', actions:[],
                                    title:app.localization.spaBooking.pmsbeforespa.notice
                                });
                            }
                        }
                        if (app.data.overridePMSRestriction) {
                            app.data.messages.push({ type:'alert', 'class':'alert-info', actions:[],
                                title:app.localization.spaBooking.pmsbeforespa.noticeOverridden,
                                message:''
                            });
                        }
                        var user = {},
                            group = [];
                        if (loadProfileData) {
                            user = r_fcp && r_fcp.Customer
                                    ? ($.isArray(r_fcp.Customer) ? r_fcp.Customer[0] : r_fcp.Customer)
                                    : {};
                            group = r_fgm && r_fgm.GroupMember
                                    ? ($.isArray(r_fgm.GroupMember) ? r_fgm.GroupMember : [r_fgm.GroupMember] )
                                    : []
                        }
                        var dateList = (location.PMSRoomMandatory == "Y" ? (!!app.data.pmsDateList ? app.data.pmsDateList[location.PropertyId] : []) : [])
                        if (app.data.RestrictedFolio) {
                            dateList = app.data.datesForRestrictedFolio
                        }

                        app.views.spaView.event.fire('requestSpaServiceSelection', [ r_sc, showitem, location, date, time, staffGenderOrId, guestName, dateList, user, group ]);

                        if (!!showitem) {
                            if (location.AllowStaff == "Y") {
                                $.when(app.models.spaModel.getData('spaStaff', { 'SpaItemId':showitem }))
                                    .done(function (r_ssf) {
                                        app.views.spaView.event.fire('updateSpaServiceStaffList', {showitem:showitem, staffList:r_ssf.SpaStaff, staffGenderOrId:staffGenderOrId, location:location});
                                    })
                            } else if (location.AllowGender == "Y") {
                                app.views.spaView.event.fire('updateSpaServiceStaffList', {showitem:showitem, staffList:[], staffGenderOrId:staffGenderOrId, location:location});
                            }

                        }
                        if (runQuery) {
                            self.spaItemSelected(showitem, date, time, staffGenderOrId, guestName)
                        }
                    })
                    .fail(function (r_ss) {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                            title:app.localization.spaBooking.serviceSelection.err.noService /*,
                            message:"(" + r_ss.Result.Text + ")"*/
                        });
                        app.dispatcher.redirect('spaBooking');
                    });
            })
        },
        
        spaServiceStaffListRequested:function (showitem, skipStaff, type, value) {
            $.when(
                skipStaff || app.models.spaModel.getData('spaStaff', {SpaItemId:showitem}),
                app.models.spaModel.getData('spaLocations', {})
            )
                .done(function (r_ssf, r_l) {
                    var location = app.models.spaModel.getSelectedItem('spaLocations', {});
                    app.views.spaView.event.fire('updateSpaServiceStaffList', {showitem:showitem, staffList:(skipStaff?{}:r_ssf.SpaStaff), staffGenderOrId:app.data.staffGenderOrId, location:location, type:type, value:value});
                })
        },
        spaPartialPayment: function (folioId, folioCustomerId) {
            if (app.data.userLoggedIn) {
                var isAllowedAccess = app.customization.spaBooking.allowPartialPayment 
                $.when(
                        app.models.userModel.getData('fetchCustomerSpaBookings', {
                            CustomerId: app.data.CustomerId,
                            CustomerGUID: app.data.CustomerGUID,
                            BookStatus: "RESERV"
                        }))
                    .done(function (folios) {
                        var spaFolio = _.find(folios.SpaFolio, function (folio) {
                            return folio.SpaFolioId == folioId
                        })
                        if (spaFolio) {
                            resolvePermission(isAllowedAccess, spaFolio).then(function (isAllowed) {
                                app.views.spaView.event.fire('requestSpaPartialPayment', [spaFolio, folioId,isAllowed])
                            })   
                        } else app.views.spaView.event.fire('requestSpaPartialPayment', ['', folioId])   
                    })
                    .fail(function (err) {
                        app.views.spaView.event.fire('requestSpaPartialPayment', ['', folioId])
                    })
            } else {
                app.data.loginNextURL = ['spaBooking', 'partialPayment', [folioId, folioCustomerId]]
                app.data.messages.push({
                    type: 'alert',
                    'class': 'alert-error',
                    actions: [],
                    title: app.localization.general.postPayment.loginFirst,
                    message: ''
                });
                app.dispatcher.redirect('profile', 'login', ["partial-payment"]);
            }
            function resolvePermission(customization, spaBooking) {
                    if (typeof customization == "function") {
                        return customization(spaBooking).then(function (isAllowed) {
                            return Promise.resolve(isAllowed)
                         })
                    } else if (typeof customization == "boolean") return Promise.resolve(customization);
                }
        },
        spaItemSelected:function (itemId, date, time, staffGenderOrId, guestName) {
            if (!/\d{4}/.test(time)) {
                app.dispatcher.replace('spaBooking', 'service', [itemId, date, "", staffGenderOrId, guestName])
                return;
            }
            if (!/\d{4}-\d{2}-\d{2}/.test(date)) {
                app.dispatcher.replace('spaBooking', 'service', [itemId, "", time, staffGenderOrId, guestName])
                return;
            }
            if (staffGenderOrId==='') {
                staffGenderOrId="X"
            }
            app.models.spaModel.setSelected('spaServicesByCategory', {}, itemId);
            var location = app.models.spaModel.getSelectedItem('spaLocations', {});
            if (!app.customization.login.atCheckOut && !app.data.userLoggedIn) {
                app.dispatcher.redirect('profile', 'login', ['next', 'spaBooking', !!app.customization.spaBooking.alwaysQueryPrice?'service':'serviceItem', itemId, date, time, staffGenderOrId, guestName, !!app.customization.spaBooking.alwaysQueryPrice?"1":"" ]);
            } else {
                var params = {SpaItemId:itemId, StartDateTime:date + time + "00", GuestName:guestName  };
                if (staffGenderOrId == "M" || staffGenderOrId == "F" || staffGenderOrId == "P" || staffGenderOrId == "X") {
                    $.extend(params, {Gender:staffGenderOrId});
                } else if (staffGenderOrId) {
                    $.extend(params, {SpaStaffId:staffGenderOrId});
                }
                if (app.customization.spaBooking.alwaysQueryPrice) {
                    time = time - 1
                    if(time % 100 == 99) {
                        time-=40
                    }
                    time = "" + time
                    while(time.length<4) {
                        time = "0"+time
                    }
                    params.StartDateTime=date + time + "00"
                }
                $.when(
                    app.customization.spaBooking.alwaysQueryPrice && app.models.spaModel.getData('spaStaff', {SpaItemId:itemId}),
                    app.models.spaModel.getData('spaAvailability', params)
                    )
                    .done(function (r_ss, r_sa) {
                        console.log('r_sa', r_sa);
                        // StartTime
                        // AvailabilityId
                        // SpaStaffId

                        if (app.customization.spaBooking.alwaysQueryPrice) {
                            app.views.spaView.event.fire('updateSpaItemAvailability', {itemId:itemId, date:date, time:time, staffGenderOrId:staffGenderOrId, guestName:guestName, spaAvailability:r_sa, spaStaffList:r_ss, location:location });
                        } else {
                            if (r_sa.SpaAvailability.length == 1 && r_sa.SpaAvailability[0].StartTime == date + time + "00") {
                                // the requested time is available
                                app.controllers.spaController.bookSpaItem(itemId, date, time, r_sa.SpaAvailability[0].SpaStaffId, guestName, staffGenderOrId, 0);

                            } else {
                                // this is an alternate time
                                var message = {
                                    type:'spaAlternateService',
                                    'class':'',
                                    title:undefined,
                                    message:undefined,
                                    actions:[]
                                };
                                _.each(r_sa.SpaAvailability, function (sa) {
                                    message.actions.push({
                                        // include price here if it differs from the std item price
                                        text:sa.StartTime,
                                        url:'#/spaBooking/book/' + [itemId, sa.StartTime.substr(0, 10), sa.StartTime.substr(10, 4), sa.SpaStaffId, guestName, staffGenderOrId, 0].join('/'),
                                        label:undefined,
                                        loading:undefined,
                                        data: sa
                                    })
                                })
                                app.data.messages.push(message);
                                app.dispatcher.replace('spaBooking', 'service', [itemId, date, time, staffGenderOrId, guestName])
                            }
                        }
                    })
                    .fail(function (r_ss, r_sa) {
                        if (app.customization.spaBooking.alwaysQueryPrice) {
                            app.views.spaView.event.fire('updateSpaItemAvailability', {itemId:itemId, date:date, time:time, staffGenderOrId:staffGenderOrId, guestName:guestName, spaAvailability:r_sa, spaStaffList:r_ss, location:location});
                        } else {
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title: app.localization.spaBooking.serviceSelection.err.noAvailableAppointments + " " + app.rs.DateToString(date + time),
                                message: '' // "(" + app.models.spaModel.dataModel.spaAvailability.faildata.Result.Text + ")"
                            });
                            app.dispatcher.replace('spaBooking', 'service', [itemId, date, time, staffGenderOrId, guestName])
                            //                        app.views.spaView.event.fire('requestSpaServiceSelection', [itemId, date, time, staffGenderOrId]);
                        }
                    });
            }
        },
        bookSpaItem:function (itemId, date, time, staffId, guestName, staffGenderOrId, ignoreConflicting, guestNote) {
            if (!/\d{4}/.test(time)) {
                app.dispatcher.replace('spaBooking', 'service', [itemId, date, "", staffGenderOrId, guestName])
                return;
            }
            if (!/\d{4}-\d{2}-\d{2}/.test(date)) {
                app.dispatcher.replace('spaBooking', 'service', [itemId, "", time, staffGenderOrId, guestName])
                return;
            }
            if (!app.data.CustomerId) {
                // firstName = webfolioid
                // lastName = TempWebFolio
                // email = webfolioid @ webfolioid .com
                $.when(app.models.systemModel.getData('createCustomer', {
                    'NewCustomer.Name.FirstName':app.data.WebFolioId,
                    'NewCustomer.Name.LastName':'TempWebFolio',
                    'NewCustomer.EmailAddress':app.data.WebFolioId + '@' + app.data.WebFolioId + '.com'}))
                    .done(function (r_cc) {
                        app.datac('CustomerId', r_cc.CustomerId);
                        doTheBooking();
                    })
                    .fail(function (r_cc) {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                            title:app.localization.spaBooking.confirmation.err.createTempUserFailed,
                            message:'' //"(" + r_cc.Result.Text + ")"
                        });
                        app.dispatcher.replace('spaBooking', 'service', [itemId, date, time, staffGenderOrId, guestName]);
                    })
            } else {
                if (+ignoreConflicting) {
                    doTheBooking();
                } else {
                    checkConflicting();
                }
            }

            function checkConflicting() {
                $.when(
                    app.models.spaModel.getData('spaCustomerConflictingBookings', {SpaItemId:itemId, StartDateTime:date + time + "00", CustomerId:guestName||app.data.CustomerId}),
                    app.models.spaModel.getData('spaLocations', {})
                )
                    .done(function (r_cc, r_l) {
                        if (r_cc.SpaBooking && r_cc.SpaBooking.length > 0) {
                            var message = {
                                type:'spaConflictingBookings',
                                'class':'alert-error',
                                title:undefined,
                                message:undefined,
                                actions:[]
                            };
                            var spaBookings = _.sortBy(r_cc.SpaBooking, function (sb) {
                                return sb.StartTime
                            });
                            _.each(spaBookings, function (sb) {
                                message.actions.push({ text:sb, url:undefined, label:undefined, loading:undefined })
                                // ItemName, StartTime, EndTime, Location
                            })
                            var item = app.models.spaModel.getSelectedItem('spaServicesByCategory', {}),
                                itemName = item && item.ItemName;
                            message.locations = r_l.SpaLocation && _.groupBy( r_l.SpaLocation, "LocationId" )
                            message['finally'] = {
                                text:{SpaItemId:itemId, StartDateTime:date + time + "00", ItemName:itemName},
                                url:'#/spaBooking/book/' + [itemId, date, time, staffId, guestName, staffGenderOrId, 1].join('/'),
                                label:undefined,
                                loading:undefined
                            }
                            app.data.messages.push(message);
                            app.dispatcher.replace('spaBooking', 'service', [itemId, date, time, staffGenderOrId, guestName]);
                        } else {
                            doTheBooking();
                        }
                    })
                    .fail(function (r_cc) {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                            title:app.localization.spaBooking.confirmation.err.checkConflictingFailed ,
                            message: '' // "(" + r_cc.Result.Text + ")"
                        });
                        app.dispatcher.replace('spaBooking', 'service', [itemId, date, time, staffGenderOrId, guestName])
                    })
            }

            function doTheBooking() {
                var params = {SpaItemId:itemId, StartDateTime:date + time + "00", SpaStaffId:staffId, CustomerId:guestName||app.data.CustomerId  };
                // if (guestName) {
                //    params.GuestName = guestName || (app.data.FirstName ? app.data.FirstName+" "+app.data.LastName : "FolioCustomer");
                // }
                if (guestNote) {
                    params.GuestRequest = guestNote
                }
                params.Gender="X";
                if (staffGenderOrId == "M" || staffGenderOrId == "F" || staffGenderOrId == "P") {
                    params.Gender=staffGenderOrId;
                } else if (staffGenderOrId==staffId) {
                    delete params.Gender
                    params.StaffRequested="Y";
                }
                app.models.spaModel.getData('spaBooking', params)
                    .done(function (r_csb) {
                        console.log('r_csb', r_csb)
                        app.data.messages.push({ type:'alert', 'class':'alert-success', actions:[],
                            title:app.localization.spaBooking.confirmation.successfullBookingMessage,
                            message:app.localization.spaBooking.confirmation.customerCustomTextFooter
                        });
                        //app.models.systemModel.getData('folioBalance', {}).always(function () {
                            app.commonViewHelper.updatePlaceHolderDate(date);
                            app.models.spaModel.resetTTL('spaAvailabilityV2');
                            app.models.spaModel.resetTTL('spaAvailability');
                            if(app.data.NoSummary){
                                window.location.href = window.location.href.replace(/\|(.*)/g,'');

                                app.models.systemModel.getData('folioBookings') //get web folio details so we can display balance
                                .done(function(webFolioData){
                                    $('.orderTotal').html(app.localization.general.currencyPrefix + (+webFolioData.FolioBalance).toFixed(2) + app.localization.general.currencyPostfix)
                                    app.data.NoSummary = false;
                                })
                            }else{
                                app.dispatcher.replace('summary', 'show', []);
                            }
                        //});
                    })
                    .fail(function (r_csb) {
                     
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                            title:app.localization.spaBooking.confirmation.err.createBookingFailed,
                            message:'' // "(" + r_csb.Result.Text + ")"
                        });
                        app.dispatcher.replace('spaBooking', 'service', [itemId, date, time, staffGenderOrId, guestName])
                    })
            };

            // here package
            
        },
        // itemId, date, staffId,staffGenderOrId,guestNote,isPackage, FolioItemId, guestName,CustomerId,editPackageData,isEditingPackage

        bookSpaPackage: function (bookings, isPackage, isEditingPackage,oldStat) {
           
            var creatTempUserPromise = $.Deferred();
            var completedPromise = $.Deferred();
            var isEditingService = false // in case user has unbooked service and in middle user decides to edit other service, then instead of going to unbooked service after completing editing, redirect user to review screen       
            var localStrings = app.localization.spaBooking.packageBooking;
   
            if (!app.data.CustomerId) {
                $.when(app.models.systemModel.getData('createCustomer', {
                    'NewCustomer.Name.FirstName':app.data.WebFolioId,
                    'NewCustomer.Name.LastName':'TempWebFolio',
                    'NewCustomer.EmailAddress':app.data.WebFolioId + '@' + app.data.WebFolioId + '.com'
                }))
                .done(function (r_cc) {
                    app.datac('CustomerId', r_cc.CustomerId);
                    if(app.data.vueAppRef) {
                        app.data.vueAppRef.$store.commit('setTempUser');
                    }
                    [].concat(bookings).forEach(function(booking){
                        booking.CustomerId = r_cc.CustomerId;
                    })
                    creatTempUserPromise.resolve();
                })
                .fail(function (r_cc) {
                    if(app.data.vueAppRef) {
                        app.data.vueAppRef.$store.commit('addGlobalMessage', {
                            type: 'error',
                            message: app.localization.spaBooking.confirmation.err.createTempUserFailed
                        });
                    }
                    creatTempUserPromise.reject();
                })
            }else {
                creatTempUserPromise.resolve();
            }

            function handleFailCase(err) {
              
                if(app.data.vueAppRef){
                    var store = app.data.vueAppRef.$store;
                    _.keys(store.state.users).some(function (user, userIndex) {
                        return _.keys(store.state.users[user]).some(function (item, itemIndex) {
                            if (!store.state.users[user][item].SpaFolioItemId && !isEditingService) {
                                store.commit('changeActiveService', {
                                    user: userIndex,
                                    id: itemIndex
                                })
                                return true;
                            }
                            return false;
                        });
                    })
                    store.commit('setShowLoaderForBooking',false);
                    // store.commit('addGlobalMessage', {
                    //     type: 'error',
                    //     message: app.localization.spaBooking.confirmation.err.createBookingFailed
                    // })
                    store.commit("setbookingButtonText", localStrings.stepper.body.schedule.bookingButtonText.book)
                    if (store.state.desktopMode) {
                       
                        store.commit("setErrorMessage", err || localStrings.stepper.body.schedule.errors.failedPackageBooking)
                        store.commit('SetbookFromCart', false) //for resetting reserve button on side cart. Reserve button on side card calls bookservice from this file and to detect the click there is watch for above
                    } else store.commit('SetmobileViewMessages', {
                        key: 'fail',
                        message: err || localStrings.stepper.body.schedule.errors.failedPackageBooking
                    })
                    if (!store.state.desktopMode) window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                    if (store.state.detectedChanges.time) {
                        store.commit("SetselectedTimeOnTimePicker", ""); //uncheck selected time 
                   // store.commit("setDetectedChanges", {}); //uncheck 
                    }
                    clearMobileMessage('fail')
                }
            }

            function clearMobileMessage(key) {
                setTimeout((function () {
                    if(app.data.vueAppRef){
                        app.data.vueAppRef.$store.commit('SetmobileViewMessages', {
                            key: key,
                            message: ""
                        })
                    }
                }), 5000)
            }

            creatTempUserPromise.then(function(){
                var uploadPackageItemData = [];
                var params = {}
                var LoaderMessage = ""
                require(['app/views/vue/store/store'], function (store) {
                    store.commit('setShowLoaderForBooking', true)
                    if (!isPackage) {
                      
                        var deferred3 = $.Deferred() //for tracking bookings
                        var deferred2 = $.Deferred() // for tracking "clearing bookings"
              
                        if (bookings[0].SpaFolioItemId) { //bookings array contains multple booking objects when booking for all guest at once. But when editing this only contains 1 booking object at any time so using[0] to get SpaFolioItemId
                            console.log("565", 'es editing', bookings)
                            LoaderMessage =  Localization.spaBooking.packageBooking.stepper.body.schedule.status.bookingPackage.rebooking
                            store.commit('setStatus',LoaderMessage )
                            var detectedChange = store.state.detectedChanges //to see what changed when user editing
                            if((detectedChange.time || detectedChange.staff) && !bookings[0].bookingOnDifferentDay){ 
                                console.log("565-1", "yes staff or time changed")
                                var clonedBookings = JSON.parse(JSON.stringify(bookings))
                                unBookItemOrService(clonedBookings)
                            } else deferred2.resolve()
                        } else deferred2.resolve()
                        $.when.call(this, deferred2.promise()).always(function (e) { // deferred2 is resolved in both case if user is editing or booking for first time. In case of editing, if time or staff changes then it first clear booking then resolve deferred2 else it would jst resolve without clearing. In case of not editing, it would just resolve, to trigger booking.
                            var clonedBookings = JSON.parse(JSON.stringify(bookings))
                            bookSingleService(clonedBookings)
                            $.when.call(this, deferred3.promise()).always(function (e) {
                                store.state.showLoaderForBooking = false
                                var notAllBooked = _.keys(store.state.users).some(function (user, userIndex) {
                                    return _.keys(store.state.users[user]).some(function (item, itemIndex) {
                                        if (!store.state.users[user][item].SpaFolioItemId && !isEditingService) {
                                         
                                            store.commit('changeActiveService', {
                                                user: userIndex,
                                                id: itemIndex
                                            })
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    });
                                })
                                if(Customization.spaBooking.onetimeBookerLocations && _.isArray(Customization.spaBooking.onetimeBookerLocations) && Customization.spaBooking.onetimeBookerLocations.indexOf(app.data["selected/spa/spaLocations/SpaLocation/"]) > -1){
                                    store.commit("setFirstTimeOtbBook", true);
                                    if(oldStat == "E"){
                                        store.commit('setActiveStep', 2);
                                    }
                                }else{ 
                                !notAllBooked ? store.commit('setActiveStep', 2) : null // if all booked go to next screen; accomodating serial bookin
                                }
                            })
                        })

                        function bookSingleService(booking) {
                           
                            if (booking.length == 0) {
                                deferred3.resolve();
                                return;
                            }
                            var bookingInfo = booking.shift()
                            console.log(" perform a single booking")
                            LoaderMessage = 
                            !bookingInfo.SpaFolioItemId ? localStrings.stepper.body.schedule.status.booking + " for " + bookingInfo.username.split('-')[0] : ''

                            store.commit("setStatus", LoaderMessage)
                            params = {
                                SpaItemId: bookingInfo.itemId.split('-')[0],
                                StartDateTime: bookingInfo.dateTime,
                                SpaStaffId: bookingInfo.staffId,
                                SpaFolioItemId: bookingInfo.SpaFolioItemId
                            };
                          
                            if (bookingInfo.guestNote) {
                                params.GuestRequest = bookingInfo.guestNote
                            }
                            if (bookingInfo.CustomerId) {
                                params.CustomerId = bookingInfo.CustomerId
                            }
                            if (bookingInfo.SpaFolioItemId) {
                                delete params.SpaItemId //cannot pass spaitemid if spafolioitem id is present
                                isEditingService = true
                            }
                            if (["M", "F", "P", 'X'].indexOf(bookingInfo.staffGenderOrId) > -1) {
                                params.Gender = bookingInfo.staffGenderOrId;
                                params.StaffRequested = "N";
                            } else if (bookingInfo.staffGenderOrId == bookingInfo.staffId) {
                                params.StaffRequested = "Y";
                            }
                            if (isEditingService) { // means if booked
                                params = modifyParamsForEditing(params) //onlydirtly data is sent as param
                            }
                          

                            var reservedTimesForUser = store.state.reservedTimes[bookingInfo.CustomerId] || [];
                            console.log("single service param", params)
                            app.models.spaModel.getData('packageSpaBooking', params)
                                .done(function (r_csb) {
                                    isEditingService ? saveDirtyDataToStore(bookingInfo.CustomerId, bookingInfo.itemId, false) : null // after successful edit, put dirtytemp data to store. this ran here to make sure edit was successful
                                    console.log('r_csb', r_csb)
                                    Object.keys(store.state.users)[store.state.activeUser]
                                    store.commit('addGlobalMessage', {
                                        type: 'success',
                                        message: app.localization.spaBooking.confirmation.successfullBookingMessage
                                    })
                                    console.log("store in control")
                                    store.commit('SetmobileViewMessages', {
                                        key: 'success',
                                        message: r_csb.rawData.ItemName + " for " + bookingInfo.username + " is successfully reserved"
                                    })
                                    clearMobileMessage('success')
                                    if (store.state.desktopMode) window.scrollTo({
                                        top: 0,
                                        behavior: 'smooth'
                                    });
                                    console.log("success booked single from package", app.views)
                                    var bookingProgressPerUser = store.state.bookingProgressPerUser
                                    store.commit('setBookingProgressPerUser', bookingProgressPerUser + 1);
                                    store.commit('SetbookFromCart', false);
                                    var payload = {
                                        userId: bookingInfo.CustomerId,
                                        id: bookingInfo.itemId,
                                        bookingStatus: localStrings.sideCart.service.body.bookingStatus.booked,
                                        ModeStatus: "View Mode",
                                        SpaFolioItemId: r_csb.rawData.SpaFolioItemId,
                                        bookingDetails: {
                                            SpaStaffId: bookingInfo.staffId,
                                            StartDateTime: r_csb.rawData.BookStartTime,
                                            endDateTime: r_csb.rawData.BookEndTime
                                        },
                                        staffGender: bookingInfo.staffGender
                                    }
                                    if(bookingInfo.guestNote){
                                        app.data.classGuestNotes =  app.data.classGuestNotes || {}
                                         app.data.classGuestNotes[r_csb.rawData.SpaFolioItemId]  = bookingInfo.guestNote 
                                         app.datal('classGuestNotes', app.data.classGuestNotes)
                                    }
                                    if (["M", "F", "P", 'X'].indexOf(bookingInfo.staffGenderOrId) > -1) {
                                        payload.autoAssignedStaff = bookingInfo.staffId
                                        payload.autoAssignedStaffName = bookingInfo.staffName
                                       
                                    }
                                    if (bookingInfo.SpaFolioItemId) {
                                        payload.bookingStatus = localStrings.sideCart.service.body.bookingStatus.updated
                                        reservedTimesForUser.forEach(function (obj) {

                                            if (obj.SpaItemId && obj.SpaItemId.split('-')[0] == r_csb.SpaItemId && obj.SpaFolioItemId == r_csb.rawData.SpaFolioItemId) {
                                                store.commit('removeReservedTime', {
                                                    FolioItemId: obj.SpaFolioItemId,
                                                    id: obj.SpaItemId,
                                                    userId: bookingInfo.CustomerId
                                                })
                                            }
                                        })
                                    }
                                    store.commit("setBookingStatusAndFolio", payload)
                                    
                                    var payload2 = {
                                        time: moment(r_csb.rawData.BookStartTime, 'YYYY-MM-DDHHmmss').format('hh:mm a'),
                                        userId: bookingInfo.CustomerId,
                                        id: bookingInfo.itemId,
                                        isPackage: false,
                                    };
                                    store.commit("setBookingTime", payload2);
                                    //for setting date
                                    var payload4 = {
                                        date: moment(r_csb.rawData.BookStartTime, 'YYYY-MM-DDHHmmss').format(localStrings.stepper.body.schedule.dateBarDaysFormat),
                                        userId: bookingInfo.CustomerId,
                                        id: bookingInfo.itemId,
                                    }
                                    store.commit("setDate", payload4);
                                    //for setting reserved time
                                    var payload3 = {
                                        data: {
                                            StartTime: r_csb.rawData.BookStartTime,
                                            EndTime: r_csb.rawData.BookEndTime,
                                            activity: r_csb.rawData.ItemName,
                                            SpaItemId: bookingInfo.itemId,
                                            isFutureBooking: false,
                                            SpaFolioItemId: r_csb.rawData.SpaFolioItemId,
                                            bookingType: "spaBooking"
                                        },
                                        id: bookingInfo.CustomerId
                                    }
                                    
                                    store.commit("addReservedTime", payload3);
                                    var bookingDetail = {
                                        bookingDate: moment(r_csb.rawData.BookStartTime, 'YYYY-MM-DDHHmmss').format('ddd, MMM D @ hh:mm A'),
                                        username: bookingInfo.username
                                    }
                                    var payload5 = {
                                        service: r_csb.rawData.ItemName,
                                        bookingDetail: bookingDetail,
                                        isPackage: false,
                                        isEditingService: isEditingService
                                    }
                                    store.commit('setReviewScreenBookingDetails', payload5)
                                    bookSingleService(booking)
                                    app.commonViewHelper.updatePlaceHolderDate(params.StartDateTime);
                                    app.models.spaModel.resetTTL('spaAvailabilityV2');
                                    app.models.spaModel.resetTTL('spaAvailability');
                                })
                                .fail(function (r_csb) {
                                 
                                  //  handleFailCase()
                                  handlePackageFailCase()
                                }).always(function(){
                                    completedPromise.resolve()
                                })
                        }
                    } else {
                        var deferred = $.Deferred();
                        var deferred2 = $.Deferred();
                        var errorList = [];
                        var successfullyBookedItems = {} // if it  fails, we clear these items that were booked, before we rebook whole package again.
                        var booking_success_message = ""
                        var packageItemId = bookings.itemId.split('-')[0];
                        var combination = bookings.bookingItems //each items
                        var combination_length = combination.length
                        LoaderMessage = localStrings.stepper.body.schedule.status.bookingPackage.booking
                        store.commit("setStatus", LoaderMessage);
                        if (!isEditingPackage) {
                            params = {
                                SpaItemId: packageItemId,
                                StartDateTime: bookings.dateTime
                            };
                            if (bookings.CustomerId) {
                                params.CustomerId = bookings.CustomerId
                            }
                            console.log("paramfor package header", params)
                            app.models.spaModel.getData('packageSpaBooking', params)
                                .done(function (r_csb) {
                                    store.commit('addGlobalMessage', {
                                        type: 'success',
                                        message: app.localization.spaBooking.confirmation.successfullBookingMessage
                                    })
                                    app.models.spaModel.resetTTL('spaAvailabilityV2');
                                    app.models.spaModel.resetTTL('spaAvailability');
                                    //var username = Object.keys(store.state.users)[store.state.activeUser]
                                    var username =  store.state.usersWithIds[bookings.CustomerId]
                                    booking_success_message = r_csb.rawData.ItemName + " for " + username + " is successfully reserved"
                                    var spaItems = [].concat(r_csb.SpaPackage[0].PackageItem)
                                    console.log("spaitem", spaItems)
                         
                                    spaItems.forEach(function (item) {
                                        combination.forEach(function (selectedItem) {
                                            if (item.SpaItemId == selectedItem.SpaItemId) {
                                                selectedItem.SpaFolioItemId = item.SpaFolioItemId
                                            }
                                        })
                                    })
                                  
                                    bookPackageItem(combination, r_csb.SpaFolioItemId, r_csb.rawData.ItemName)
                                    app.commonViewHelper.updatePlaceHolderDate(params.StartDateTime);
                                })
                                .fail(function (r_csb) {
                                    handleFailCase()
                                })
                        } else {
                            LoaderMessage = Localization.spaBooking.packageBooking.stepper.body.schedule.status.bookingPackage.rebooking
                            store.commit('setStatus', LoaderMessage)
                            var clonedConflictingItems = JSON.parse(JSON.stringify(combination))
                            var detectedChange = store.state.detectedChanges //to see what changed when user editing
                            // detectedChange.time || detectedChange.staff ? unBookItemOrService(clonedConflictingItems) : deferred2.resolve() // we only clear conflicting time when time or staff was edited. deferred 2 resolved after clearing time. If we are only editing staff or note then just resolve directly
                            if((detectedChange.time || detectedChange.staff) && !bookings.bookingOnDifferentDay) { unBookItemOrService(clonedConflictingItems) }else deferred2.resolve() // we only clear ecisting conflicting bookings if package start time or staff of conflicting item was changed. Deferred2 gets  resolved after clearing time. If we are only editing note or package start time is on diffrent day then just resolve directly.
                            $.when.call(this, deferred2.promise()).always(function (e) {
                               var clonedConflictingItems = JSON.parse(JSON.stringify(combination))
                                bookPackageItem(clonedConflictingItems)
                            })
                         
                        }
                        var i = 0

                        function bookPackageItem(combination, packageFolioItemId, packageName) {
                            if (combination.length == 0) {
                                deferred.resolve();
                                completedPromise.resolve();
                                return
                            }
                            var package_item = combination.shift()
                            var params = {
                                StartDateTime: package_item.StartDateTime,
                                SpaFolioItemId: package_item.SpaFolioItemId
                            };
                            if (package_item.guestNote) {
                                params.GuestRequest = package_item.guestNote
                            }
                            if (bookings.CustomerId) {
                                params.CustomerId = bookings.CustomerId
                            }
                            params.SpaStaffId = package_item.SpaStaffId
                            if (["M", "F", "P", 'X'].indexOf(package_item.staffGenderOrId) > -1) {
                                params.Gender = package_item.staffGenderOrId;
                                params.StaffRequested = "N";
                            } else if (package_item.staffGenderOrId == package_item.SpaStaffId) {
                                params.StaffRequested = "Y";
                            }
                            isEditingPackage ? params = modifyParamsForEditing(params) : ''
                            console.log("package_item", package_item)
                            console.log("params", params)
                            app.models.spaModel.getData('packageSpaBooking', params)
                                .then(function (r_csb) {
                                    app.models.spaModel.resetTTL('spaAvailabilityV2');
                                    app.models.spaModel.resetTTL('spaAvailability');
                                        console.log("after booking activity packager_csb", r_csb)
                                        !isEditingPackage? store.state.status = localStrings.stepper.body.schedule.status.bookingPackage.booked + " " + (i + 2) + "/" + combination_length + " " + localStrings.stepper.body.schedule.status.bookingPackage.items : ''
                                        console.log("state", store.state.status)
                                        //add booked time to reserved times array as item is being booked
                                        var userId = Object.keys(store.state.users)[store.state.activeUser]
                                        var item = {
                                            data: {
                                                StartTime: package_item.StartDateTime,
                                                EndTime: moment(package_item.StartDateTime, 'YYYY-MM-DDHHmmss').add(package_item.duration, 'minutes').format('YYYY-MM-DDHHmmss'),
                                                SpaItemId: package_item.SpaItemId,
                                                activity: package_item.name,
                                                isFutureBooking: false,
                                                SpaFolioItemId: r_csb.rawData.SpaFolioItemId,
                                                parentSpaFolioItemId: packageFolioItemId
                                            },
                                            id: bookings.CustomerId
                                        }
                                        var payload = {
                                            userId: userId,
                                            id: bookings.itemId, // package service id
                                            bookingStatus: localStrings.sideCart.service.body.bookingStatus.booked,
                                            SpaFolioItemId: r_csb.SpaFolioItemId,
                                            itemId: r_csb.SpaItemId, // actual item id
                                            isPackage: true,
                                            isEditingPackage: isEditingPackage,
                                            autoAssignedStaff: package_item.SpaStaffId,
                                            autoAssignedStaffName: package_item.staffName,
                                            staffGender: package_item.staffGender,
                                            index: i
                                        }
                                        console.log("pkg payload", payload)
                                        var payload2 = {
                                            time: moment(package_item.StartDateTime, 'YYYY-MM-DDHHmmss').format('hh:mm a'),
                                            dateTime: package_item.StartDateTime,
                                            itemId: r_csb.SpaItemId, // actual item id
                                            userId: userId,
                                            id: bookings.itemId, // package service id
                                            isPackage: true,
                                            isEditingPackage: isEditingPackage,
                                            index: i
                                        };
                                        //   for review page- booking info
                                        var bookingDetail = {
                                            bookingTime: moment(package_item.StartDateTime, 'YYYY-MM-DDHHmmss').format('hh:mm A'),
                                            bookingDate: moment(r_csb.rawData.BookStartTime, 'YYYY-MM-DDHHmmss').format('ddd, MMM D @ hh:mm A'),
                                            itemName: package_item.name
                                        }
                                        if(package_item.guestNote){
                                            app.data.classGuestNotes =  app.data.classGuestNotes || {}
                                             app.data.classGuestNotes[r_csb.SpaFolioItemId]  = package_item.guestNote 
                                             app.datal('classGuestNotes', app.data.classGuestNotes)
                                        }
                                      
                                        var payload3 = {
                                            service: packageName || r_csb.rawData.SpaPackage.ItemName, //when editing package, packagename field is not avail
                                            bookingDetail: bookingDetail,
                                            isPackage: true,
                                            userId: userId,
                                            isEditingService: isEditingPackage
                                        }
                                        var storeMutations = {
                                            'addReservedTime': item,
                                            'setBookingStatusAndFolio': payload,
                                            'setBookingTime': payload2,
                                            'setReviewScreenBookingDetails': payload3
                                        }
                                        if (errorList.length <= 0 && combination.length == 0) { // mean all booked successfuly.wiLL ONLY SAVE PACKAGE HEADER FOLIO ID WHEN ALL ARE BOOKEDS
                                            store.state.users[userId][bookings.itemId].bookingStatus = localStrings.sideCart.service.body.bookingStatus.booked
                                            packageFolioItemId ? store.state.users[userId][bookings.itemId].SpaFolioItemId = packageFolioItemId : ""
                                            store.state.users[userId][bookings.itemId].bookingDetails = {
                                                'StartDateTime': bookings.dateTime
                                            }
                                            var payload4 = {
                                                date: moment(package_item.StartDateTime, 'YYYY-MM-DDHHmmss').format(localStrings.stepper.body.schedule.dateBarDaysFormat),
                                                userId: userId,
                                                id: bookings.itemId,
                                            }
                                            store.commit("setDate", payload4);
                                            if (isEditingPackage) {
                                                var username =  store.state.usersWithIds[bookings.CustomerId]
                                                booking_success_message = package_item.name + " for " + username + " is successfully updated "
                                                saveDirtyDataToStore(bookings.CustomerId, bookings.itemId, true)
                                            }
                                        }
                                        uploadPackageItemData[i] = storeMutations
                                        i = i + 1
                                        successfullyBookedItems[r_csb.SpaItemId]= true
                                      
                                        bookPackageItem(combination, packageFolioItemId, packageName) //recursive
                                    },
                                    function (err) {
                                        err.Result.SpaFolioItemId = package_item.SpaFolioItemId
                                        err.Result.ItemName = package_item.ItemName
                                        err.Result.SpaItemId = package_item.SpaItemId
                                        errorList.push(err.Result)
                                        handlePackageFailCase(packageItemId, packageFolioItemId,successfullyBookedItems)
                                    })
                        }
                        return $.when.call(this, deferred.promise()).always(function (e) {

                                store.state.mobileSuccessMessage = booking_success_message
                                store.commit('SetmobileViewMessages', {
                                    key: 'success',
                                    message: booking_success_message
                                })
                                clearMobileMessage('success')
                                if (store.state.desktopMode) window.scrollTo({
                                    top: 0,
                                    behavior: 'smooth'
                                });
                                store.commit('addGlobalMessage', {
                                    type: 'success',
                                    message: app.localization.spaBooking.confirmation.successfullBookingMessage
                                })
                                store.state.showLoaderForBooking = false
                                uploadPackageItemData.forEach(function (item) {
                                    store.commit("addReservedTime", item.addReservedTime);
                                    store.commit("setBookingStatusAndFolio", item.setBookingStatusAndFolio);
                                    store.commit("setBookingTime", item.setBookingTime)
                                    store.commit("setReviewScreenBookingDetails", item.setReviewScreenBookingDetails)
                                })
                                store.commit("sortPackageItems", {userId:bookings.CustomerId,id:bookings.itemId}) 
                                var notAllBooked = _.keys(store.state.users).some(function (user, userIndex) {
                                    return _.keys(store.state.users[user]).some(function (item, itemIndex) {
                                        if (!store.state.users[user][item].SpaFolioItemId && !isEditingService) {
                                           
                                            store.commit('changeActiveService', {
                                                user: userIndex,
                                                id: itemIndex
                                            })
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    });
                                }) 
                                !notAllBooked ? store.commit('setActiveStep', 2) : null // if all booked go to next screen; 
                            
                        })
                    }

                    function unBookItemOrService(items) {
                        if (items.length == 0) {
                            deferred2.resolve();
                            return
                        }
                        var bookingInfo = items.shift()
                        var params = {
                            SpaFolioItemId: bookingInfo.SpaFolioItemId,
                            StartDateTime: ""
                        };
                        app.models.spaModel.getData('packageSpaBooking', params)
                            .then(function (r_csb) {
                                app.models.spaModel.resetTTL('spaAvailabilityV2');
                                app.models.spaModel.resetTTL('spaAvailability');
                                console.log("debug-334", r_csb,items)
                                store.commit('removeReservedTime', {
                                    FolioItemId: r_csb.SpaFolioItemId,
                                    id: r_csb.SpaItemId,
                                    userId: bookingInfo.CustomerId
                                })
                                unBookItemOrService(items)
                            }).always(function(){
                                completedPromise.resolve()
                            })
                    }
                    function saveDirtyDataToStore(userId, itemId, isSchedulingPackage) {
                        var data = store.state.dataForBookingService
                        var detectedChange = store.state.detectedChanges
                        _.each(data, function (val, key) {
                            var payload = {
                                note: data[key].note,
                                userId: userId,
                                isPackage: isSchedulingPackage,
                                id: itemId,
                                packageItemId: key, // if scheduling package then itemid is indv item id for each item
                                staffName: data[key].staffName,
                                staffGenderOrId: data[key].staff, //id,
                                staffGender: data[key].staffGender

                            }
                            if (detectedChange.note) store.commit("setNote", payload)
                            if (detectedChange.staff) store.commit("setStaff", payload)

                        })
                    }

                    function modifyParamsForEditing(params) {
                        var detectedChange = store.state.detectedChanges
                        if (!detectedChange.time && !detectedChange.staff ) { //only note change
                            delete params.StartDateTime //to make sure if only note is changed, then resist staffid and startdatetime in rs application by not sending datetime at all!
                            delete params.SpaStaffId
                        }
                        return params
                    }

                    

                    function handlePackageFailCase(packageItemId, FolioItemId, successfullyBookedItems) {
                        if (isPackage && isEditingPackage|| isEditingService) {
                            clearAndRebookPackage(successfullyBookedItems).then(function(){
                                handleFailCase() //general error handling   
                            })
                        }
                        else{
                            if(isPackage){
                                FolioItemId ? app.controllers.cartController.removeItem("Spa", packageItemId, FolioItemId, true).then(function () {
                                }) : ''
                            }
                            handleFailCase() //general error handling
                        }

                        function clearAndRebookPackage(successfullyBookedItems) //it will only clear those items that actually got booked and then will book whole package again. Since booking happens in serial order, it ensures that when I clear them first, rebooking is not overlapped 
                        {
                            var overAllPormise = $.Deferred()
                           
                                var userId = Object.keys(store.state.users)[store.state.activeUser]
                                var itemsToClear =[]
                                var originalBooking = []
                                if(isPackage){
                                    var packageItems = store.state.users[userId][bookings.itemId].package_item.PackageItems.PackageItem
                                     originalBooking = _.map(packageItems, function (items) {
                                    var data = {
                                        SpaItemId: items.SpaItemId,
                                        StartDateTime: items.dateTime,
                                        SpaStaffId: items.autoAssignedStaff || items.staffGenderOrId,
                                        guestNote: items.note,
                                        duration: items.ServiceTime,
                                        name: items.ItemName,
                                        staffGenderOrId: items.staffGenderOrId,
                                        staffName: items.autoAssignedStaff ? items.autoAssignedStaffName : items.staffName,
                                        staffGender: items.staffGender,
                                        SpaFolioItemId: items.SpaFolioItemId,
                                        CustomerId:userId
                                    }
                                    return data
                                    })
                                    itemsToClear = [].concat(_.filter(originalBooking, function (item) {
                                    return successfullyBookedItems[item.SpaItemId]
                                    }))
                                }
                                else{
                                   
                                    var service = store.state.users[userId][bookings[0].itemId] //in case of single booking bookings is an array 
                                    var data = {
                                        guestNote: service.note,
                                        itemId: service.SpaItemId,
                                        SpaFolioItemId: service.SpaFolioItemId,
                                        staffId: service.bookingDetails.SpaStaffId,
                                        CustomerId: service.username,
                                        staffGenderOrId : service.staffGenderOrId,
                                        staffName: service.autoAssignedStaffName || service.staffName,
                                        staffGender: service.staffGender,
                                        dateTime:  service.bookingDetails.StartDateTime,
                                        username:store.state.usersWithIds[service.username]
                                      }
                                    originalBooking = [].concat(data)
                                }
                                deferred = $.Deferred();
                                deferred2 = $.Deferred();
                                deferred3 = $.Deferred()
                             
                               unBookItemOrService(itemsToClear,originalBooking)
                                LoaderMessage = localStrings.stepper.body.schedule.status.bookingPackage.revertPackageChanges
                                store.commit('setStatus', LoaderMessage)
                                $.when.call(this, deferred2.promise()).always(function (e) {
                                    isPackage ? bookPackageItem(originalBooking): bookSingleService(originalBooking)  // rebook same package/service  again
                                })
                                $.when.call(this, [deferred.promise()]).always(function (e) {
                                    overAllPormise.resolve()
                                })
                           
                            return overAllPormise;
                        }
                    }
                })
            }).fail(function(){
                handleFailCase(app.localization.spaBooking.confirmation.err.createTempUserFailed);
                completedPromise.resolve();
            })
            return completedPromise;
        },
    spaClassSelected:function (spaLocationId, startDate, showItem, guestName) {
/*
TODO: call validatePMSBeforeSpa from every controller action that renders ui and can possibly be an entry point to the flow.
*/
            var spaItemId = undefined,
                self = this,
                location = undefined;
            if (spaLocationId && spaLocationId.substr(0, 8) == "Location") {
                var showitemParts = spaLocationId.split('|');
                spaLocationId=showitemParts[0].substr(8);
                app.models.spaModel.setSelected('spaLocations', {}, spaLocationId);
                spaItemId = showitemParts[1];
            }
            var self = this,
                location = undefined,
                loadProfileData = false,
                params = {};

            if (app.data.userLoggedIn) {
                loadProfileData = true;
                params = {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    },
                    dfd = $.Deferred();
                app.models.userModel.getData('fetchGroupMembers', params ).always(function(x){
                    dfd.resolve(x);
                })
                var profileParams = {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    }
            }
            $.when(
                app.models.spaModel.getData('spaLocations', {}),
                (loadProfileData && app.models.userModel.getData('fetchCustomerProfile', profileParams )),
                (loadProfileData && dfd.promise())
            ).done(function (r_sl, r_fcp, r_fgm){
                location = app.models.spaModel.getSelectedItem('spaLocations', {});
                $.when(
                    (location.PMSRoomMandatory == "Y" && app.models.systemModel.validatePMSBeforeSpa(location.LocationName))
                )
                    .done(function (r_pbs) {
                        var spaLocations = r_sl.SpaLocation;
                        if (app.customization.hideOtherPropertyIfItemsInCart && (app.data.spaPropertyIdsInCart.length > 0 || app.data.pmsPropertyIdsInCart.length > 0)) {
                            spaLocations = _.filter(spaLocations,function(x){
                                return !!location && location.LocationId == x.LocationId &&
                                    (_.any(app.data.spaPropertyIdsInCart, function(y){ return y==x.PropertyId }) || _.any(app.data.pmsPropertyIdsInCart, function(y){ return y==x.PropertyId }))
                            })
                            if (spaLocations.length==0) {
                                app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                    title:app.localization.spaBooking.locationSelection.err.mismatchedProperty,
                                    message: '' // r_pr.Result ? "(" + r_pr.Result.Text + ")" : ""
                                });
                                app.dispatcher.redirect('summary','',[]);
                                return;
                            }
                        }
                        if (r_pbs) {
                            app.data.messages.push({ type:'alert', 'class':'alert-info alert-no-autoclose', actions:[],
                                title:app.localization.spaBooking.pmsbeforespa.notice
                            });
                        }
                        if (app.data.overridePMSRestriction) {
                            app.data.messages.push({ type:'alert', 'class':'alert-info', actions:[],
                                title:app.localization.spaBooking.pmsbeforespa.noticeOverridden,
                                message:''
                            });
                        }
                        var user = {},
                            group = [];
                        if (loadProfileData) {
                            user = r_fcp && r_fcp.Customer
                                    ? ($.isArray(r_fcp.Customer) ? r_fcp.Customer[0] : r_fcp.Customer)
                                    : {};
                            group = r_fgm && r_fgm.GroupMember
                                    ? ($.isArray(r_fgm.GroupMember) ? r_fgm.GroupMember : [r_fgm.GroupMember] )
                                    : []
                        }
                        var dateList = location.PMSRoomMandatory == "Y"
                                        ? ( !!app.data.pmsDateList ? app.data.pmsDateList[location.PropertyId] : [] )
                                        : [];
                        !startDate && dateList && dateList.length>0 && (startDate=dateList[0].machine)
                        if (app.data.RestrictedFolio) {
                            dateList = app.data.datesForRestrictedFolio
                        }
                        app.views.spaView.event.fire('requestSpaClassDateSelection', [spaLocationId, startDate, dateList, guestName, user, group, location]);
                        if (startDate) {
                            app.dispatcher.dispatch('spaBooking', 'findclass', [spaLocationId, startDate, showItem, guestName, spaItemId])
                        }
                    })
                    .fail(function (r_pbs) {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                            title:app.localization.spaBooking.classSelection.err.classListFailed,
                            message:''//"(" + r_ss.Result.Text + ")"
                        });
                        app.dispatcher.redirect('spaBooking');
                    })
            });
        },
        getEvents : function(spaLocationId, start, end){

            return app.models.spaModel.getData('spaClasses', {StartDate: start.toString('yyyy-MM-dd'), EndDate: end.toString('yyyy-MM-dd')})
                .then( function(r_sc) {
                    if (!r_sc || !r_sc.DailySpaClasses) {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            //title:Localization.spaBooking.classSelection.classNotAvail,
                            message:Localization.spaBooking.classSelection.classNotAvail
                        });
                        return;
                    }

                    r_sc.DailySpaClasses = $.wrapArray(r_sc.DailySpaClasses)
                    _.each(r_sc.DailySpaClasses,function(dailySpaClasses){
                        if (!!dailySpaClasses.SpaClass) {
                            dailySpaClasses.SpaClass = $.wrapArray(dailySpaClasses.SpaClass)
                            var classes = [],
                                classesBySpaClassId = _.groupBy( dailySpaClasses.SpaClass,'SpaClassId')
                            _.each(classesBySpaClassId,function(classGroup){
                                classGroup[0]._staffIds = _.pluck(classGroup,'SpaStaffId')
                                classes.push(classGroup[0])
                            })
                            dailySpaClasses.SpaClass = classes
                        }
                    })
                    return r_sc.DailySpaClasses
                })
        },
        spaClassDateSelected : function ( spaLocationId, startDate , showItem, guestName, spaItemId) {
            var endDate = startDate; // Date.parse(startDate).add(1).days().toString('yyyy-MM-dd');
            $.when ( app.models.spaModel.getData('spaClassesByCategory', {StartDate:startDate, EndDate:endDate}))
                .done( function(r_sc) {
                    if (r_sc != undefined) {
                        showItem = showItem || // $.firstOrOnly($.first(r_sc).value.value).SpaItemId;
                                            ( $.isArray(r_sc) && $.isArray($.first(r_sc).value) &&
                                                r_sc.length==1 && $.first(r_sc).value.length==1
                                                ? $.firstOrOnly($.first(r_sc).value.value).SpaClassId : "" );
                        if (spaItemId && !_.any(r_sc, function(x){
                            return _.any(x.value,function(y){
                                return y.SpaItemId == spaItemId
                            })
                        })) {
                            app.data.messages.push({ type:'alert', 'class':'alert-info', actions:[],
                                title:app.localization.spaBooking.classSelection.spaItemNotFound,
                                message:''
                            });
                        }
                        app.views.spaView.event.fire('requestClassSelection',[r_sc, startDate, showItem, spaLocationId, guestName, spaItemId]);
                    } else {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            //title:Localization.spaBooking.classSelection.classNotAvail,
                            message:Localization.spaBooking.classSelection.classNotAvail
                        });
                        app.views.spaView.event.fire('updateMessages');
//                        app.dispatcher.replace('golfBooking','course',[app.models.golfModel.getSelectedValue('golfCourses')])
                    }
                })
                .fail( function( r_sc) {
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                       // title:app.localization.spaBooking.classSelection.classNotAvail,
                        message:app.localization.spaBooking.classSelection.classNotAvail
                    });
                    app.views.spaView.event.fire('updateMessages', []);
//                    app.dispatcher.replace('golfBooking','course',[app.models.golfModel.getSelectedValue('golfCourses')])
                });

        },

        spaClassConfirmation: function(bookingtype, spaLocationId, classId, itemId, startDate,hasGroupMember ){
            $.when(
                
                app.models.spaModel.getData('spaLocations', {}).then(function(r_sl){
                    app.models.spaModel.setSelected('spaLocations', {}, spaLocationId);
                    return r_sl
                }),
                app.models.spaModel.getData('spaClassesFlat', {StartDate:startDate.substr(0,10), EndDate: startDate.substr(0,10)}),
                (location.PMSRoomMandatory == "Y" && app.models.systemModel.validatePMSBeforeSpa(location.LocationName))
            )
                .done(function( r_sl, r_scf, r_pbs){
                    app.models.spaModel.setSelected('spaClassesFlat', {StartDate:startDate.substr(0,10), EndDate: startDate.substr(0,10)}, classId);
                    var item = app.models.spaModel.getSelectedItem('spaClassesFlat', {StartDate:startDate.substr(0,10), EndDate: startDate.substr(0,10)});
                    var location = app.models.spaModel.getSelectedItem('spaLocations',{});
                    if (r_pbs) {
                        app.data.messages.push({ type:'alert', 'class':'alert-info alert-no-autoclose', actions:[],
                            title:app.localization.spaBooking.pmsbeforespa.notice
                        });
                    }
                    console.log("conClassid",classId)
                    console.log("itemId",itemId,app.data.spaClassQueue)
                    app.views.spaView.event.fire('confirmSpaClass', [location,item,spaLocationId, classId, itemId, startDate, bookingtype,hasGroupMember]);
                })


        },
        spaEventCalendar: function(spaLocationId, startDate, showItem, guestName, spaItemId,promoCode) {
            var self = this,
                location = undefined,
                loadProfileData = false,
                params = {};
            if(promoCode) app.datal('eventCalendarPromoCode',promoCode)
            if (app.data.userLoggedIn) {
                loadProfileData = true;
                params = {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    },
                    dfd = $.Deferred();
                app.models.userModel.getData('fetchGroupMembers', params ).always(function(x){
                    dfd.resolve(x);
                })
                var profileParams = {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    }
            }
            $.when(
                app.models.spaModel.getData('spaLocations', {}),
                (loadProfileData && app.models.userModel.getData('fetchCustomerProfile', profileParams )),
                (loadProfileData && dfd.promise())
            ).done(function(r_sl, r_fcp, r_fgm){
                if (spaLocationId) {
                    if (spaLocationId.substr(0, 8) == "Location") {
                        var showitemParts = spaLocationId.split('|');
                        spaLocationId=showitemParts[0].substr(8);
                        spaItemId = showitemParts[1];
                    }
                    app.models.spaModel.setSelected('spaLocations', {}, spaLocationId);
                } else {
                    if (!app.models.spaModel.getSelectedItem('spaLocations',{})) {
                        app.dispatcher.redirect('spaBooking', '', []);
                        return
                    }
                }
                var user = {},
                    group = [];
                if (loadProfileData) {
                    user = r_fcp && r_fcp.Customer
                            ? ($.isArray(r_fcp.Customer) ? r_fcp.Customer[0] : r_fcp.Customer)
                            : {};
                    group = r_fgm && r_fgm.GroupMember
                            ? ($.isArray(r_fgm.GroupMember) ? r_fgm.GroupMember : [r_fgm.GroupMember] )
                            : []
                }
                app.views.spaView.event.fire('spaEventCalendar', [spaLocationId, startDate, showItem, guestName, spaItemId, user, group]);
            })
            .fail(function (r_sl) {
                app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                   // title:app.localization.spaBooking.classSelection.classNotAvail,
                    message:app.localization.spaBooking.classSelection.classNotAvail
                });
                app.dispatcher.redirect('spaBooking', '', []);
            })
        },
    
        bookSpaClass: function (spaLocationId, classId, itemId, startDate, guestName, confirmed,hasGroupItem,hasGrouping) {
                var endDate = startDate;
                isEventCalender = ($.isArray(app.customization.spaBooking.eventCalendarLocations) && app.customization.spaBooking.eventCalendarLocations.indexOf(spaLocationId) >= 0) 
                 
                if (!app.data.userLoggedIn) {
                    var bookingObj = isEventCalender ? app.data.user_equipment_not_loggedin : {
                        ItemId: itemId,
                        ClassId: classId,
                        StartDateTime: startDate,
                        CustomerId: app.data.CustomerId, //if exist
                        equipment_id: '',
                        equipment_name: '',
                    }
                    if (!app.data.CustomerId) {
                        $.when(app.models.systemModel.getData('createCustomer', {
                                'NewCustomer.Name.FirstName': app.data.WebFolioId,
                                'NewCustomer.Name.LastName': 'TempWebFolio',
                                'NewCustomer.EmailAddress': app.data.WebFolioId + '@' + app.data.WebFolioId + '.com'
                            }))
                            .done(function (r_cc) {
                                app.datac('CustomerId', r_cc.CustomerId);
                                bookingObj.CustomerId = r_cc.CustomerId
                                checkConflicting(bookingObj.CustomerId, bookingObj.ItemId, bookingObj.ClassId, bookingObj.StartDateTime, bookingObj.guestNote,bookingObj.equipment_id, bookingObj.equipment_name, '', hasGroupItem,isEventCalender,bookingObj.optionalClassList,hasGrouping)
                                    .always(function (rr) {
                                        app.datal('user_equipment_not_loggedin', {})
                                    })
                            })
                            .fail(function (r_cc) {
                                var errorTitle = app.localization.spaBooking.confirmation.err.createTempUserFailed
                                handleError(errorTitle, "")
                                app.dispatcher.replace('spaBooking', 'class', ['Location' + spaLocationId, startDate, classId, guestName]);
                            })
                    } else {
                        checkConflicting(bookingObj.CustomerId, bookingObj.ItemId, bookingObj.ClassId, bookingObj.StartDateTime,bookingObj.guestNote, bookingObj.equipment_id, bookingObj.equipment_name, '', hasGroupItem,isEventCalender,bookingObj.optionalClassList,hasGrouping)
                            .always(function (rr) {
                                app.datal('user_equipment_not_loggedin', {})
                            })
                    }
                } else {
                    if (isEventCalender) {
                        var deferred = $.Deferred()
                        var Queue = JSON.parse(JSON.stringify(app.data.spaClassQueue[startDate+'-'+classId]));
                        var errList = []
                        doClassQueue(Queue);

                        function doClassQueue(queue) {
                            if (queue.length == 0) {
                                deferred.resolve()
                                return;
                            }
                            var q = queue.pop()
                           
                            if (!q.isWaitListed) {
                                checkConflicting(q.CustomerId, q.ItemId, q.ClassId, q.StartDateTime, q.guestNote,q.equipment_id, q.equipment_name, true, hasGroupItem,isEventCalender,q.optionalClassList,hasGrouping)
                                    .always(function (rr) {
                                        doClassQueue(queue);
                                    }).fail(function (err) {
                                     
                                       // var errorTitle = app.localization.spaBooking.confirmation.err.createBookingFailed
                                       // handleError(errorTitle, "")
                                    })
                            } else {
                                AddWaitList(q.ItemId, q.ClassId, q.CustomerId, '').always(function () {
                                    doClassQueue(queue)
                                }).fail(function (err) {
                                    var errorTitle = app.localization.spaBooking.confirmation.err.WaitListFailed
                                    handleError(errorTitle, "")
                                })
                            }
                            return $.when.call(this, deferred.promise()).always(function (e) {
                                $.when(app.models.spaModel.getData('spaClasses', {
                                        StartDate: startDate,
                                        EndDate: startDate
                                    }))
                                    .done(function (r_sc) {
                                        _.each(app.models.spaModel.dataModel.spaClasses.data, function (classes) {
                                            for (var i = 0; i < classes.DailySpaClasses.length; i++) {
                                               
                                                if (classes.DailySpaClasses[i].Date == r_sc.DailySpaClasses[0].Date) {
                                                    classes.DailySpaClasses[i] = r_sc.DailySpaClasses[0]
                                                }
                                            }
                                        })
                                    })

                                app.datal('spaClassQueue', {})
                                app.datal('countOfGuest', {})
                                app.dispatcher.replace('summary', 'show', []);
                            })
                        }
                    } else checkConflicting(app.data.CustomerId, itemId, classId, startDate)
                }
                function handleError(title,message){
                    app.data.messages.push({
                    type: 'alert',
                    'class': 'alert-error',
                    actions: [],
                    title: title,
                    message: message //"(" + r_cc.Result.Text + ")"
                });
            }

            function checkConflicting(customerId,itemId,classId,startDateTime,guestNote,equipmentId,equipmentName,returnPromise,hasGroupItem,isEventCalender,optionalClasses,hasGrouping) {
                var dfdBooking  = returnPromise ? $.Deferred() : '';
                var item = app.models.spaModel.getSelectedItem('spaClassesFlat', {StartDate:startDate.substr(0,10), EndDate: startDate.substr(0,10)});
                    itemName = item && item.ItemName;
                return $.when( dfdBooking,
                    $.when(
                        app.models.spaModel.getData('spaCustomerConflictingBookings', {SpaItemId:itemId||(item&&item.SpaItemId), StartDateTime:startDateTime, CustomerId:customerId}),
                        app.models.spaModel.getData('spaLocations', {})
                    )
                    .done(function (r_cc, r_l) {
                      
                        if (r_cc.SpaBooking && r_cc.SpaBooking.length > 0) {
                            var message = {
                                type:'spaConflictingBookings',
                                'class':'alert-error',
                                title:undefined,
                                message:undefined,
                                actions:[]
                            };
                            var spaBookings = _.sortBy(r_cc.SpaBooking, function (sb) {
                                return sb.StartTime
                            });
                            _.each(spaBookings, function (sb) {
                                message.actions.push({ text:sb, url:undefined, label:undefined, loading:undefined })
                                // ItemName, StartTime, EndTime, Location
                            })
                            message.locations = r_l.SpaLocation && _.groupBy( r_l.SpaLocation, "LocationId" )
                            /*message.finally = {
                                text:{SpaItemId:itemId, StartDateTime:startDate + "00", ItemName:itemName},
                                url:'#/spaBooking/bookClass/' + [classIdId, startDate, guestName].join('/'),
                                label:undefined,
                                loading:undefined
                            }*/
                            app.data.messages.push(message);
                            app.datal('spaClassQueue',{})
                            app.datal('countOfGuest',{})
                            app.datal('user_equipment_not_loggedin',{})
                            if(isEventCalender)  
                            app.dispatcher.replace('spaBooking', 'eventcalendar', ['Location'+spaLocationId, startDateTime.substr(0,10),"", classId]);
                            else
                            app.dispatcher.replace('spaBooking', 'class', ['Location'+spaLocationId, startDate, classId, guestName]);
                        } else {
                            if (+confirmed) {
                                doTheBooking(customerId,itemId,classId,startDateTime, guestNote,equipmentId,equipmentName,returnPromise,hasGroupItem,optionalClasses,hasGrouping).done(function(x){
                                    dfdBooking && dfdBooking.resolve(x)
                                }).fail(function(x){ dfdBooking && dfdBooking.reject(x)});
                            } else {
                                app.dispatcher.redirect('spaBooking','confirmClass', [spaLocationId, classId, itemId, startDate, guestName,equipmentId])
                            }
                        }
                    })
                    .fail(function (r_cc) {
                      
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                            title:app.localization.spaBooking.confirmation.err.checkConflictingFailed,
                            message:'' //"(" + r_cc.Result.Text + ")"
                        });
                        app.datal('spaClassQueue',{})
                        app.datal('countOfGuest',{})
                        app.datal('user_equipment_not_loggedin',{})
                        app.dispatcher.replace('spaBooking', 'class', ['Location'+spaLocationId, startDate, classId, guestName]);
                       
                    })
                )
            }

            function doTheBooking(customerId,itemId,classId,startDateTime,guestNote,equipmentId,equipmentName,returnPromise,hasGroupItem,optionalClasses,hasGrouping) {
                isEventCalender = ($.isArray(app.customization.spaBooking.eventCalendarLocations) && app.customization.spaBooking.eventCalendarLocations.indexOf(spaLocationId) >= 0)          
                if(isEventCalender && (+hasGroupItem != 1 || +hasGrouping != 1))
                  itemId = '';
                  
                if(isEventCalender && (+hasGroupItem != 1 && +hasGrouping == 1|| +hasGroupItem == 1 && +hasGrouping == 1)) itemId = itemId
                  
                var params = {ProgramId:classId, ItemId:itemId, CustomerId: customerId};
                if (equipmentId) {
                    params['Equipments.Equipment.ClassId'] = classId;
                    params['Equipments.Equipment.EquipId'] = equipmentId;
                }

                if(optionalClasses){
                    classIds = Object.keys(optionalClasses)
                    _.each(classIds,function(opClass,index){
                        params['Optional.SpaClassId['+index+']'] = opClass
                    })

                }
                if(guestNote) params['GuestRequest'] = guestNote
                return app.models.spaModel.getData('classBooking', params)
                    .done(function (r_csb) {
                        $.when ( app.models.spaModel.getData('spaClasses',{StartDate:startDateTime.substr(0,10), EndDate: startDateTime.substr(0,10)}))
                        .done( function(r_sc) {
                        
                            _.each(app.models.spaModel.dataModel.spaClasses.data, function (classes) {
                                for(var i=0;i<classes.DailySpaClasses.length;i++){
                           
                                    if(classes.DailySpaClasses[i].Date == r_sc.DailySpaClasses[0].Date){
                                    console.log("found")
                                        classes.DailySpaClasses[i] = r_sc.DailySpaClasses[0]
                                    }
                                }
                            })
                        })
                        app.commonViewHelper.updatePlaceHolderDate(startDateTime.substr(0,10)); //update placeholder date
                        
                        if(isEventCalender){
                        var BookedEquipmentDetails = app.data.BookedEquipmentDetails || {}
                        BookedEquipmentDetails[r_csb.SpaFolioItem[0].SpaFolioItemId] = equipmentId?  equipmentName: ''
                        app.datal("BookedEquipmentDetails",BookedEquipmentDetails)
                        }
                        returnPromise || app.data.messages.push({ type:'alert', 'class':'alert-success', actions:[],
                            title:app.localization.spaBooking.confirmation.successfullBookingMessage,
                            message:app.localization.spaBooking.confirmation.customerCustomTextFooter
                        });
                        if (r_csb.SpaFolioItem && r_csb.SpaFolioItem[0] && r_csb.SpaFolioItem[0].SpaFolioItemId) {

                            app.data.spaClassFolioItemIds = app.data.spaClassFolioItemIds || [];
                            app.data.spaClassFolioItemIds.push(r_csb.SpaFolioItem[0].SpaFolioItemId);
                          
                            if(guestNote){
                                app.data.classGuestNotes =  app.data.classGuestNotes || {}
                                !app.data.classGuestNotes.hasOwnProperty(r_csb.SpaFolioItem[0].SpaFolioItemId) ? app.data.classGuestNotes[r_csb.SpaFolioItem[0].SpaFolioItemId]  = guestNote :''
                                 app.datal('classGuestNotes', app.data.classGuestNotes)
                            }
                            if (returnPromise) {
                                return $.Deferred().resolve(r_csb)
                            }
                        }
                        if (returnPromise) {
                            return $.Deferred().resolve(r_csb)
                        } else {       
                            app.dispatcher.replace('summary', 'show', []);
                        }
                    })
                    .fail(function (r_csb) {
                       
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                            title: r_csb.Result.ErrorId == "461"? r_csb.Result.Text: app.localization.spaBooking.confirmation.err.createBookingFailed,
                            message: '' //"(" + r_csb.Result.Text + ")"
                        });
                        app.datal('spaClassQueue',{})
                        app.datal('countOfGuest',{})
                        app.datal('user_equipment_not_loggedin',{})
                        if (returnPromise) {
                            return $.Deferred().reject(r_csb)
                        }
                        if ($.isArray(app.customization.spaBooking.eventCalendarLocations) && app.customization.spaBooking.eventCalendarLocations.indexOf(spaLocationId) >= 0) {
                            var modifiedDate =  moment(startDate, 'YYYY-MM-DDHHmmss').format('YYYY-MM-DD')
                            app.dispatcher.replace('spaBooking', 'eventcalendar', ['Location'+spaLocationId, startDateTime.substr(0,10),"", classId]);
                        } else {
                            app.dispatcher.replace('spaBooking', 'class', ['Location'+spaLocationId, startDate, classId, guestName]);
                        }
                    })
            }
            function  AddWaitList(spaItemId, SpaClassId,customerId,note) {
                var SpaWaitGuests = 1
                var params = { SpaItemId: spaItemId, SpaWaitNote: note, SpaWaitGuests: SpaWaitGuests, SpaClassId: SpaClassId,CustomerId:customerId };
                var completedPromise =$.Deferred()
                app.models.spaModel.getData('WaitListRequest', params)
                        .done(function (r_csb) {
                            console.log('r_csb', r_csb)
                            app.data.messages.push({
                                type: 'alert',
                                'class': 'alert-success',
                                actions: [],
                                title: Localization.spaBooking.confirmation.successfullWaitListMessage,
                                message: app.localization.spaBooking.confirmation.customerCustomTextFooter
                            });
                            completedPromise.resolve()
                        })
                        .fail(function (r_csb) {
                            console.log('error', r_csb)
                            completedPromise.reject(r_csb)
                        })    
                return completedPromise;
            }
        },

        spaPackageSelected:function (location, activeStep, categoryFilter, category, date, selectionId) {
            var args = Array.prototype.slice.call(arguments);
            var membershipIds = app.data.membershipDetails && app.data.membershipDetails.membershipItemIds || [];
            var vipLevels = app.data.membershipDetails && app.data.membershipDetails.VIPLevels || [];
            app.commonViewHelper.eval_ttb({module:"spaBooking", item: selectionId, location: location.split('Location')[1], vipLevel: vipLevels, membershipId:membershipIds});
            // var location = app.models.spaModel.getSelectedItem('spaLocations', {});
            app.models.spaModel.getData('spaLocations').then(function(){
                app.models.spaModel.setSelected('spaLocations', {}, location.split('Location')[1]);
                app.views.spaView.event.fire('renderPackageView', {activeStep:activeStep, date:date, selectionId:selectionId, categoryFilter:categoryFilter, category:category});
            });
        },
    })
});

